@import "src/styles/common/_colors.scss";

.errorPageWrapper {
    display: flex;
    align-items: center;
    min-height: calc(100% - 60px);
    justify-content: center;
    flex-direction: column;
    .companyLogo {
        margin: 0 0 20px 5px;
        padding: 0;
    }
    .errorBlock {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .errorCode {
        color: $dark-green;
        float: left;
        margin-right: 10px;
    }
    .errorDescription {
        margin: 1rem 0;
        line-height: 1.664;
        vertical-align: middle;
    }
    
    .errorDescription p {
        margin: 0;
    }
    
    .errorDescription button {
        padding: 0px;
        text-decoration: underline;
    }
    
    .errorDescription button:hover, span:hover {
        color: $dark-green;
    }
}